import { render, staticRenderFns } from "./InventoryDetails.vue?vue&type=template&id=699ac96e"
import script from "./InventoryDetails.vue?vue&type=script&lang=js"
export * from "./InventoryDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('699ac96e')) {
      api.createRecord('699ac96e', component.options)
    } else {
      api.reload('699ac96e', component.options)
    }
    module.hot.accept("./InventoryDetails.vue?vue&type=template&id=699ac96e", function () {
      api.rerender('699ac96e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inventory/InventoryDetails.vue"
export default component.exports